import { TCustomizationContextState } from "./types"

export const customizationSelectors = {
  data: (state: TCustomizationContextState) => state.data,
  list: (state: TCustomizationContextState) => state.data.list,
  error: (state: TCustomizationContextState) => state.data.error,
  item: (state: TCustomizationContextState) => state.item,
  update: (state: TCustomizationContextState) => state.update,
}
